<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
      
        <!-- <el-button
          type="danger"
          plain
          size="mini"
          icon="el-icon-circle-close"
          :disabled="ids.length == 0"
          @click="deldteClick(ids)"
        >
          删除
        </el-button> -->
      </div>
      <!-- <div class="search_box">
        <el-input
          v-model.trim="requestData.deviceNum"
          size="mini"
          placeholder="请输入设备编号"
          clearable
        ></el-input>
        <el-input
          v-model.trim="requestData.deviceName"
          size="mini"
          placeholder="请输入设备名称"
          clearable
        ></el-input>
        <el-button
          size="mini"
          type="primary"
          @click="searchData"
          plain
          icon="el-icon-search"
          >搜索</el-button
        >
      </div> -->
    </div>
    <div class="page_table_box">
      <div class="school_table_box" v-if="responseData.list.length">
        <el-table
          :data="responseData.list"
          height="100%"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          @selection-change="handleSelectionChange"
          v-loading="loading"
        >
          <el-table-column type="selection" width="55" align="center">
          </el-table-column>
          <el-table-column label="序号" width="70" align="center">
            <template v-slot="scope">
              {{
                responseData.pageSize * (responseData.pageNo - 1) +
                  scope.$index +
                  1
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceNum"
            label="设备序列号"
            align="center"
          >
          <template v-slot="scope">
              <span >{{ scope.row.deviceSerial }}</span>
              <!-- <input v-if="isEdit" type="number"  v-model=" scope.row.deviceSerial "> -->
            </template>
        </el-table-column>
          <el-table-column prop="deviceName" label="设备名称" align="center">
            <template v-slot="scope">

            <span v-if="!isEdit">{{ scope.row.deviceName }}</span>
              <el-input v-if="isEdit" type="text"  v-model=" scope.row.deviceName " />
            </template>
            </el-table-column>
        
          <el-table-column
            prop="communicationType"
            label="通讯类型"
            align="center"
          >
          <template v-slot="scope">
          <span v-if="scope.row.communicationType">{{ getcommunicationType(scope.row.communicationType)  }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="deviceModel"
            label="设备型号"
            align="center"
          >
          <template v-slot="scope">
          <span v-if="scope.row.deviceModel">{{ getdeviceModel(scope.row.deviceModel)  }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="deviceType"
            label="设备类型"
            align="center"
          >
          <template v-slot="scope">
          <span v-if="scope.row.deviceType">{{ getdeviceType(scope.row.deviceType)  }}</span>
          </template>
          </el-table-column>
          <el-table-column
            prop="unitStatus"
            label="部件状态"
            align="center"
          >
            <template v-slot="scope">
              <span v-if="scope.row.unitStatus == 1">正常</span>
              <span v-if="scope.row.unitStatus == 0">故障</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="deviceStatus"
            label="设备状态"
            align="center"
          >
            <template v-slot="scope">
              <span v-if="scope.row.deviceStatus == 1">在线</span>
              <span v-if="scope.row.deviceStatus == 0">离线</span>
              <span v-if="scope.row.deviceStatus == 2">未注册</span>

            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" width="180" align="center">
            <template v-slot="scope">
              <el-link
               v-if="!isEdit&&scope.row.id!=editId"
                class="link_box"
                type="primary"
                :underline="false"
                @click="editClick(scope.row)"
                >编辑</el-link
              >
              <el-link
               v-if="isEdit&&scope.row.id==editId"
                class="link_box"
                type="primary"
                :underline="false"
                @click="saveClick(scope.row)"
                >保存</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="deldteClick(scope.row)"
                >删除</el-link>
              
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class="pagination_box">
        <el-pagination
          v-if="responseData.total > 0"
          @current-change="handleCurrentChange"
          :current-page="requestData.pageNo"
          :page-size="requestData.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="responseData.total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      :append-to-body="true"
      :title="drawerType == 'add' ? '新增消防设备' : '编辑消防设备'"
      :visible.sync="showDrawer"
      direction="ltr"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <el-form
        :model="objInfo"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="drawer-form-box"
      >
        <el-col :span="12">
        <el-form-item label="设备名称:" prop="deviceName">
          <el-input
            v-model.trim="objInfo.deviceName"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备序列号:" prop="deviceSerial">
          <el-input
            v-model.trim="objInfo.deviceSerial"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="通讯类型:" prop="communicationtype">
          <el-select
                style="width:200px"
                v-model="communicationtype"
                placeholder="请选择通讯类型"
                clearable
              >
              <el-option
                v-for="item in communicationType"
                :key="item"
                :label="communicationType[item]"
                :value="item"
              >
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备型号:" prop="deviceModel">
          <el-select
                style="width:200px"
                v-model="deviceModel"
                placeholder="请选择设备型号"
                clearable
              >
              <el-option
                v-for="item in equipmentModel"
                :key="item"
                :label="equipmentModel[item]"
                :value="item"
              >
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型:" prop="deviceType">
          <el-select
                style="width:200px"
                v-model="deviceType"
                placeholder="请选择设备类型"
                clearable
              >
              <el-option
                v-for="item in equipmentType"
                :key="item"
                :label="equipmentType[item]"
                :value="item"
              >
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备所属厂商:" prop="producterID">
          <el-select
                style="width:200px"
                v-model="producterID"
                placeholder="请选择所属厂商"
                clearable
                @change="changeSelect"
              >
              <el-option
                v-for="item in producterList"
                :key="item"
                :label="producterList[item]"
                :value="item"
              >
             </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物模型:" prop="producterID">
          <el-select
                style="width:200px"
                v-model="productModelID"
                placeholder="物模型"
                clearable
                @change="changeSelects"
              >
              <el-option
                v-for="item in productModelIDList"
                :key="productModelIDList[item]"
                :label="item"
                :value="item"
              >
             </el-option>
          </el-select>
        </el-form-item>
        
      </el-col>
      <el-col :span="12">
        <el-form-item label="详细位置:" prop="location">
          <el-input
            v-model.trim="objInfo.location"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否自动添加传感器:" prop="autoAddChannel">
         
          <el-radio-group v-model="objInfo.autoAddChannel" >
            <el-radio :label="true" >是</el-radio>
            <el-radio :label="false" >否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单位ID:" prop="unitID">
          <el-input
            v-model.trim="objInfo.unitID"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="经度:" prop="lat">
          <el-input
            v-model.trim="objInfo.lat"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lon">
          <el-input
            v-model.trim="objInfo.lon"
            clearable
            size="small"
            style="width:90%"
          ></el-input>
        </el-form-item>
      </el-col>
        <!-- <el-form-item label="是否需要短信通知:" prop="sendSMS">
          <el-radio-group v-model="objInfo.sendSMS" size="mini">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="2" border>否</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>

      <el-divider></el-divider>
      <div class="drawer-save-btn-box">
        <el-button
          type="primary"
          size="small"
          @click="saveForm('ruleForm')"
          v-loading="saveLoading"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small" v-loading="saveLoading"
          >返回</el-button
        >
      </div>
    </el-dialog>
    <alertInfo :alertResize="alertResize" :detail="detail"></alertInfo>
    <websocket-alert></websocket-alert>
  </div>
</template>

<script>
import alertInfo from "./components/ProtectDeviceManagementInfo";
import websocketAlert from "./components/ProtectDeviceManagementWebsocket";
export default {
  name: "ProtectDeviceManagement",
  components: {
    alertInfo,
    websocketAlert
  },
  props: {},
  data() {
    var reg = /^1[3456789]\d{9}$/;
    var checkPhone = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(" "));
      } else if (!reg.test(value)) {
        callback(new Error(" "));
      } else {
        callback();
      }
    };
    return {
      requestData: {
        schoolId: this.$store.state.schoolId,
        pageSize: 20,
        pageNo: 1,
        type:1
        // deviceNum: "",
        // deviceName: ""
      },
      responseData: {
        total: 0,
        list: []
      },
      isEdit:false,
      editId:'',
      drawerType: "add",
      showDrawer: false,
      objInfo: {
        autoAddChannel:true,
        schoolId: this.$store.state.schoolId, //所属学校
        deviceName: "", // 设备名称
        location:"",
        producterID:'',
        // verificationCode:'',
        communicationType:'',
        deviceType:'',
        deviceModel:'',
        deviceSerial:'',
        unitID:'',
        lat:'',
        lon:"",
        productModelID:null
      },
      deviceModel:"",
      deviceType:"",
      communicationtype:'',
      producterID:'',
      productModelID:'',
      communicationType:{},
      equipmentModel:{},
      equipmentType:{},
      producterList:{
             180001: '海康威视'
      },
      productModelIDList:{
             360032: '海康MQTT通用物模型-99013914'
      },

      saveLoading: false,
      ids: [],
      alertResize: 0,
      loading:false,
      detail: {},
      rules: {
        deviceSerial: [{ required: true, message: " ", trigger: "blur" }],
        deviceName: [{ required: true, message: " ", trigger: "blur" }],
        location: [{ required: true, message: " ", trigger: "blur" }],
        loopId: [{ required: true, message: " ", trigger: "blur" }],
        partId: [{ required: true, message: " ", trigger: "blur" }],
        endPointType: [{ required: true, message: " ", trigger: "blur" }],
        installationPosition: [
          { required: true, message: " ", trigger: "blur" }
        ],
        alarmTelephone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        sendSMS: [{ required: true, message: " ", trigger: "blur" }],
        deviceModel: [{ required: true, message: " ", trigger: "change" }],
      }
    };
  },
  watch: {},
  methods: {
    getcommunicationType(data){
      let datas = ''
      for(var i in this.communicationType ){
        if(data==i){
          datas =  this.communicationType[i]
        }
      }
      return datas
      
    },
    getdeviceModel(data){
      let datas = ''
      for(var i in this.equipmentModel ){
        if(data==i){
          datas =  this.equipmentModel[i]
        }
      }
      return datas
      
    },
    getdeviceType(data){
      let datas = ''
      for(var i in this.equipmentType ){
        if(data==i){
          datas =  this.equipmentType[i]
        }
      }
      return datas
    },
    changeSelect(e){
        console.log(e)
    },  
    changeSelects(e){
      console.log(e)
    },
    handleCurrentChange(val) {
      this.requestData.pageNo = val;
      this.searchClick();
    },
    searchData() {
      this.requestData.pageNo = 1;
      this.searchClick();
    },
    async searchClick() {
      let res = await this.$Http.getSafeEquipment(this.requestData);
      if (res.code == 200) {
        console.log(1111,res)
        this.responseData = res.data;
        this.responseData.list = res.data.list || [];
        this.responseData.total = res.data.total || 0;
      } else if (res.code == 101) {
        this.responseData.list = [];
        this.responseData.total = 0;
        this.$message({
          type: "infor",
          message: res.messsage || "暂无数据"
        });
      } else {
        this.responseData.list = [];
        this.responseData.total = 0;
        this.$message({
          type: "error",
          message: res.messsage || "设备列表获取失败"
        });
      }
    },
    check(row) {
      this.detail = row;
      this.alertResize++;
    },
    // 多选删除
    handleSelectionChange(val) {
      this.ids = val.map((item) => {
        return item.deviceId || "";
      });
    },
    // 新增按钮
    addClick() {
      this.drawerType = "add";
      this.showDrawer = true;


    },
    editClick(row) {
      this.isEdit=true
      this.editId=row.id
    },
  async  saveClick(row){

      if(!row.deviceName) return   this.$message({
          type: "warning",
          message: '设备名称不得为空'
        });
        if(!row.location) return   this.$message({
          type: "warning",
          message: '安装位置不得为空'
        });
        this.loading=true
      let res = await this.$Http.editSafeEquipments({
        deviceID:row.deviceID,
        deviceName:row.deviceName,
        location:row.location

      });
      console.log(res)
      this.loading=false
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.isEdit=false
      this.editId=''
        this.searchClick();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || ""
        });
      }
    },
    saveForm(){
      this.addOrEditForm()
    },
    async addOrEditForm() {
      let url =
        this.drawerType == "add" ? "addSafeEquipments" : "editSafeEquipments";
    
      for(var i in this.communicationType ){
        if(this.communicationtype==this.communicationType[i]){
          this.objInfo.communicationType=Number(i) 
        }
      }
      
      for(var i in this.equipmentModel ){
        if(this.deviceModel==this.equipmentModel[i]){
          this.objInfo.deviceModel=Number(i) 
        }
      }
      for(var i in this.equipmentType ){
        if(this.deviceType==this.equipmentType[i]){
          this.objInfo.deviceType=Number(i) 
        }
      }
      for(var i in this.producterList ){
        if(this.producterID==this.producterList[i]){
          this.objInfo.producterID=Number(i) 
        }
      }
      for(var i in this.productModelIDList ){
        if(this.productModelID==this.productModelIDList[i]){
          this.objInfo.productModelID=Number(i) 
        }
      }
      
      this.objInfo.lat= Number(this.objInfo.lat)
      this.objInfo.lon= Number(this.objInfo.lon)

      let res = await this.$Http[url](Object.assign({}, this.objInfo));
      if (res.code == 200) {
        // if (this.drawerType == "edit") {
        //   this.editSafeEquipmentSms();
        // } else {
        this.searchClick();
        // }
        this.handleClose();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "设备提交失败"
        });
      }
    },
    // 关闭弹窗
    handleClose() {
      this.showDrawer = false;
      this.recoverData();
    },
    // 恢复初始数据
    recoverData() {
      this.$refs.ruleForm.resetFields();
      this.objInfo = {
        autoAddChannel:true,
        schoolId: this.$store.state.schoolId, //所属学校
        deviceName: "", // 设备名称
        location:"",
        producterID:'',
        // verificationCode:'',
        communicationType:'',
        deviceType:'',
        deviceModel:'',
        deviceSerial:'',
        unitID:'',
        lat:'',
        lon:""
      };
    },
    // 删除提示框
    deldteClick(row) {
      this.$confirm("此操作将永久删除消防设备, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.deldteinfo(row.deviceID);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 删除数据
    async deldteinfo(ids) {
      console.log(ids);
      this.loading=true
      // return
      let req = {
        deviceID: ids
      };
      let res = await this.$Http.delSafeEquipments(req);
      this.loading=false
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功"
        });
        this.searchClick();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "设备删除失败"
        });
      }
      
    },
    // 开启关闭短信报警
    async editSafeEquipmentSms() {
      let req = {
        state: this.objInfo.sendSMS,
        deviceId: this.objInfo.deviceId
      };
      let res = await this.$Http.editSafeEquipmentSms(req);
      if (res.code == 200) {
        this.searchClick();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage || "修改短信报警失败"
        });
      }
    },
    async getEquipmentType(){
      let res = await this.$Http.getSafeEquipmenttype();
      if (res.code == 200) {
        console.log(res)
        this.communicationType= res.data.communicationType
        this.equipmentModel =res.data.equipmentModel        
        this.equipmentType =res.data.equipmentType        

      } else if (res.code == 101) {
      } else {
       
      }
    }
  },

  created() {
    this.getEquipmentType()
  },
  mounted() {
    this.searchClick();
  },
  computed: {
    deviceStatus() {
      return [
        { id: 0, name: "在线" },
        { id: 1, name: "离线" }
      ];
    }
  }
};
</script>
